import BigNumber from 'bignumber.js';

import { DlVault } from 'types/contracts';

export interface GetInviterInput {
  dlVaultContract: DlVault;
  accountAddress: string;

}

export type GetInviterOutput = {
  inviter: string;
};

const getInviter = async ({
                               dlVaultContract,
                               accountAddress,
}: GetInviterInput): Promise<GetInviterOutput> => {
  const res = await dlVaultContract.methods.inviter(accountAddress).call();

  return {
    inviter: res,
  };
};

export default getInviter;
